import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from 'recharts';

import { formatNumber } from '@/features/reports/lib/format';
import { fa } from '../i18n/fa';
import ChartCard from './ChartCard';
import { ChartLegend, chartTooltipStyle } from './chartTheme';

const PALETTE = ['var(--green)', 'var(--red)', '#F59E0B', '#1E88E5', '#00897B', '#8E24AA', 'var(--gray-dark)'];

export default function AlertsByRuleChart({ alerts, onRuleSelect }) {
  const counts = {};
  alerts.forEach((a) => (counts[a.rule] = (counts[a.rule] || 0) + 1));
  const rows = Object.entries(counts).map(([rule, value]) => ({
    rule,
    name: fa.ruleName(rule),
    value,
  }));
  return (
    <ChartCard title={fa.charts.alertsByRule} empty={rows.length === 0}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={rows}
            dataKey="value"
            nameKey="name"
            innerRadius="45%"
            outerRadius="68%"
            stroke="none"
            onClick={(entry) => {
              const rule = entry?.payload?.rule ?? entry?.rule;
              if (rule) onRuleSelect?.(rule);
            }}
            style={{ cursor: onRuleSelect ? 'pointer' : undefined }}
          >
            {rows.map((_, i) => <Cell key={i} fill={PALETTE[i % PALETTE.length]} />)}
          </Pie>
          <Tooltip
            contentStyle={chartTooltipStyle}
            formatter={(value, name) => [formatNumber(value), name]}
          />
          <ChartLegend />
        </PieChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
